import React from "react";
import "./App.css";
import Hero from "./components/hero";
import Details from "./components/details";
import Form from "./components/form";
import Footer from "./components/footer";
import ScrollToFormButton from "./components/ScrollToFormButton";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useEffect } from "react";

function App() {
  const pageView = async () => {
    try {
      await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/visitors`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          authorization: process.env.REACT_APP_JWT_SECRET || "your-secret-key",
        },
      });
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    pageView();
  }, []);

  return (
    <div className="App">
      <Hero />
      <Details />
      <Form />
      <Footer />
      <ScrollToFormButton />
      <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
    </div>
  );
}

export default App;
